<template>
    <div>


    <el-dialog
      :visible.sync="mianDialog.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      @close="close"
      :width="(mianDialog.width+160)+'px'"
      center
    >
      <div class="order_main3" id="printContent" :style="{width:mianDialog.width+'px'}">
         <div class="every" v-for="(pobj,pIndex) in boxId" :key="pIndex" style="height:350px;margin-bottom: 93px;">
           <div class="order_header" >
           <img :src="pobj.faceImg" class="code_img" @click="flashPiture">
         </div>

         <div class="grandpa">
           <div class="parentLeft">
             <div class="imgBlock">
              <img :src="pobj.faceImg" class="newCodeImg"  @click="flashPiture">
             </div>
           </div>
           <div class="parentRight">
            <div class="deliverBox">
              <div class="sentenOne"><span class="fontOne"></span><span class="fontTwo"></span></div>
              <div class="sentenOne"><span class="fontOne"></span><span class="fontTwo">{{pobj.deliveryTitle}}</span></div>
            </div><br/>
            <div class="order_detail">
              
              <div class="product_list">
                  <div class="l_item" v-if="pobj && pobj.orderPojoList && pobj.orderPojoList[0]">
                    <span class="l_item_val vipCode">{{pobj.orderPojoList[0].vipCode}}</span>
                    <div class="order_count" style="clear:both;width:250px;margin-top:30px">
                <div style="float:left;margin-left:-40px;">订单名称：{{getOrderName(pobj.orderPojoList[0].productName)}}</div>

               <div style="float:right;width:140px;">
                  <span>　运单号：{{pobj.orderPojoList[0].expressNo}}</span>
               </div>

              </div>
                    <!-- <span class="l_item_val" style="float:left;margin-left:-40px;">{{pobj.orderPojoList[0].productName}}</span>
                    <span class="l_item_val" >{{pobj.orderPojoList[0].expressNo}}</span> -->
                     <div style="margin-left:120px;">
                    </div>
                    
                  </div><br/>
                  <div style="float:right;margin:-140px -40px 0 0px;">
                    <h1 style="display:inline-block;margin-top:-60px;font-size:80px;">{{pobj.isHybrid == 1 ? "混" : ""}}</h1><br/>
                  </div>
                  <!-- <div class="l_item" v-if="mianDialog.boxInfo.orderCount>8">...还剩余{{mianDialog.boxInfo.orderCount-8}}个订单</div> -->
                  <div class="box_footer2">
                    
                    <div class="box_type">
                    </div><br>
                    <div>
                    </div>
                    <br />
                  </div> 
              </div>

              <div class="order_count" style="clear:both">
                <div style="float:left;margin-left:-40px;">订单数量：{{pobj.orderCount}}</div>

               <div style="float:right">
                  <span>运输方式：{{goodType(pobj.goodType)}}</span>
               </div>

              </div>
             

            </div>
           </div>
         </div>
         </div>

      </div>
      
      <div class="parentFooter">
        <span slot="footer" class="dialog-footer">
          <br/>
          <el-button type="primary" v-print="printObj">打 印</el-button>
          <el-button @click="close">关 闭</el-button>
          
       </span>
      </div>
    </el-dialog>


    </div>
</template>
<script>
import * as mUtils from "utils/mUtils";
import * as deliveryApi from "@/api/delivery";
import { axios } from "utils/";
import * as date from "utils/date";
import * as StringUtils from 'utils/StringUtils'
import * as unit from 'utils/unit'
import * as boxApi from "@/api/box";
export default {
    props:{
      // boxId:{
      //     type:Number,
      //     default:null
      // }
      boxId:{
          type:Array,
          required:true
      }
    },
    data(){
        return{
          httpImg:"",  
          mianDialog:{
            show:true,
            title:"面单",
            width:"300",
            height:"260",
            boxId:null,
            boxInfo:{},
            list:[]
          },
          printObj: {
            id: "printContent",
            popTitle: "",
            extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
          },
          imgURL:null,
          vipCodeArr:[],
        }
    },

    created() {
        let that = this;
        that.httpImg =process.env.IMG_URL;
        that.mianDialog.width = unit.mmToPx(100);
        //that.mianDialog.height = unit.mmToPx(100);
        
    },
    methods:{
      close(){
          // this.$emit('closeFaceDialog', true);
          this.$emit('closeFaceDialog', false);

      },  
      async getFaceSheet(){
        let that = this;
        if (!that.boxId) return;
        let param ={};
        param.boxId = that.boxId;
        await boxApi.faceSheet(param).then(res=>{
            if (res.data.code !=0){
                return that.$message.error(res.data.msg || "获取异常")
            }
            that.mianDialog.boxInfo = res.data.data;
            let list = res.data.data.orderPojoList || [];
            if (list != null && list.length>0){
                if (list.length>8){
                    list = list.slice(0,8); 
                }
                that.mianDialog.list = list;
                console.log(148,that.mianDialog.list);
                let vipCodeArr = [];
                that.mianDialog.list.forEach(vipCode=>{
                  vipCodeArr.push(vipCode.vipCode);
                })
                this.vipCodeArr = [...new Set(vipCodeArr)];
                console.log(153,vipCodeArr,this.vipCodeArr);
                // that.mianDialog.list = that.mianDialog.list.concat(list)
                // that.mianDialog.list = that.mianDialog.list.concat(list)
                // that.mianDialog.list = that.mianDialog.list.concat(list)
                // that.mianDialog.list = that.mianDialog.list.concat(list)
            }
            //that.mianDialog.list = res.data.data.orderPojoList || [];
            this.imgURL=this.httpImg+this.mianDialog.boxInfo.img
        })  
      },
    toDate(time,fmt){
      if (!time) return "";
      return date.formatDate(new Date(time),fmt);
    },
    goodType(goodType){
      return StringUtils.goodType(goodType);
    },
    flashPiture(){
      this.imgURL = this.imgURL+'?'+ Math.random();
      
    },
    // 订单名称超出6位显示省略号
    getOrderName(value){
      if(value.length>6){
        return value.substring(0,7)+"..."
      }else{
        return value;
      }
    },
    }
}
</script>

<style lang="less" scoped>
.order_main3 {
  
  margin-left: 15px;
  padding-left:50px;
  .order_header {
    // border-bottom: 1px solid #e1e1e1;
    width:100%;
    text-align: center;
    .code_img {
      height: 40px;
      width:110%;
    }
  }
  .grandpa{
    padding:20 0 20 20px;
    .parentLeft{
      float:left;
      width:147px;
      height:auto;
      // background:red;
      .imgBlock{
        width:100%;height:230px;
        // background:blue;
        .newCodeImg{
          width:360px;
          height:22%;
          margin: 152px 0 0 -136px;
          transform:rotate(270deg);
        }
      }
    }
    .parentRight{
      width:220px;
      float:right;
        .deliverBox {
          padding: 3px 0;
          // border-bottom: 1px solid #e1e1e1;
          .sentenOne{
            margin-left:-40px;
            .fontTwo{
              font-size: 56px;
              font-weight: bold;
            }
          }
    span {
      font-size: 12px;
      display: inline-block;
    }
    .l_label2{
        margin-left: 5px;
    }
    .l_value {
      font-size: 12px;
    }
  }
  .order_address {
    padding: 3px 0;
    border-bottom: 1px solid #e1e1e1;
    .p1 {
      font-size: 12px;
    }
  }
  .order_detail {
    margin-top: 5px;
    font-size: 12px;
    .order_count {
      margin-top:-30px;
      font-size: 24px;
      font-weight: 600;
    }
  }
    }
  }

  .product_list {
     margin-top:2px;
    .l_item {
      padding: 1px 0;
      font-size: 12px;
      .l_item_val {
        margin-right: 6px;
        display: inline-block;
        vertical-align: middle;
        font-size: 12px;
      }
      .vipCode{
        font-size: 60px;
        text-indent: -40px;
      }
      .l_name {
        font-size: 12px;
        max-width: 90px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        vertical-align: middle;
      }
    }

    .box_footer2 {
      margin-top: 5px;
      position: relative;
      span {
        display: inline-block;
      }
      .box_time {
        span {
          font-size: 12px;
        }
      }
      .box_type {
        position: absolute;
        right: 5px;
        top: 0;
        span {
          font-size: 12px;
          font-weight: 600;
        }
      }
    }
  }
}
.parentFooter{
  clear: both;width: 163px;height:60px;margin:10px auto;
}
</style>


// WEBPACK FOOTER //
// face.vue?6df199d0